import { useState, useEffect } from 'react';
import { _photoCache, getAttractionPhoto } from '../constants';

const useAttractionPhoto = (name, category, idx, city = '', isVisible = true, nameEn = '') => {
  const fallback = getAttractionPhoto(category, idx);
  const [src, setSrc] = useState(fallback);
  const cacheKey = city ? `${name}||${city}||${idx}` : `${name}||${idx}`;

  useEffect(() => {
    if (!isVisible) return;
    if (!name || name.length < 2) { setSrc(fallback); return; }
    // Reset synchronously when the identity (cacheKey) changes, so a hook
    // instance reused across attractions (e.g. a detail sheet swapping
    // selections without unmounting) doesn't keep showing the previous
    // attraction's photo while the new one loads.
    const cached = _photoCache[cacheKey];
    setSrc(cached !== undefined ? (cached || fallback) : fallback);
    if (cached !== undefined) return;
    let cancelled = false;
    (async () => {
      try {
        const searchName = nameEn && nameEn.length > 2 ? nameEn : name;
        const q = city ? `${searchName} ${city}` : searchName;

        const catParam = category ? `&cat=${encodeURIComponent(category)}` : '';
        const cityParam = city ? `&city=${encodeURIComponent(city)}` : '';
        const pr = await fetch(`/api/photo?v=3&query=${encodeURIComponent(q)}&idx=${idx}${catParam}${cityParam}`);
        if (pr.ok) {
          const pd = await pr.json();
          if (pd?.url) {
            _photoCache[cacheKey] = pd.url;
            if (!cancelled) setSrc(pd.url);
            return;
          }
        }

        _photoCache[cacheKey] = null;
      } catch { _photoCache[cacheKey] = null; }
    })();
    return () => { cancelled = true; };
  }, [cacheKey, isVisible]); // eslint-disable-line react-hooks/exhaustive-deps

  return src;
};

export default useAttractionPhoto;
